import energy_category from '../device_settings/energy_category.js';

export default {
	title: 'application_settings',
	components: [
		energy_category,
		{
			title: 'consumption_calculation',
			component: 'consumption_calculation',
		},
	],
};
